<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'TenantHome'
}
</script>
<style lang="">
  
</style>